<template>
    <div class="bg-white">
        <div class="container mx-auto px-6 py-2 lg:py-4 xl:px-14">
            <div class="flex flex-wrap items-center">
                <div class="w-2/5 text-left">
                    <router-link to="/"><img src="@/assets/images/logo.svg" class="h-10 w-auto h-auto max-h-10 hidden lg:block"></router-link>
                    <div class="flex items-center lg:hidden">
                        <!-- Mobile menu button-->
                        <button type="button" class="bg-gray-medium inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                            <span class="sr-only">Open main menu</span>
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" v-if="!mobileMenuOpen" @click="mobileMenuOpen = true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" v-if="mobileMenuOpen" @click="mobileMenuOpen = false">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="w-3/5 text-right">
                    <div class="hidden lg:inline-block">
                        <router-link to="/" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2" exact>{{ $t("Home") }}</router-link>
                        <router-link to="/faqs" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Faq") }}</router-link>
                        <router-link to="/premi" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Premi") }}</router-link>
                        <router-link to="/documenti" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Documenti") }}</router-link>
                        <router-link to="/contatti" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Contatti") }}</router-link>
                        <router-link to="/login" v-if="!isAuth" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Accedi") }}</router-link>
                        <router-link to="/register" v-if="!isAuth" class="text-sm sm:text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Registrati") }}</router-link>
                        <router-link to="/dashboard" v-if="isAuth" class="rounded-full bg-green-dark text-sm sm:text-sm text-white uppercase px-3 py-2 mr-2">{{ $t("Dashboard") }}</router-link>
                    </div>
                    <a class="font-bold text-teal" href="#" @click="changeLocale('en')">ENG</a>
                    <span class="inline-block font-bold text-teal mx-2">|</span>
                    <a class="font-bold text-teal" href="#" @click="changeLocale('it')">ITA</a>
                </div>
            </div>
        </div>
        <div class="container mx-auto px-6 py-4 lg:hidden text-left" v-if="mobileMenuOpen">
            <router-link to="/" class="block text-sm text-green-dark uppercase px-2 py-2 mr-2" exact>{{ $t("Home") }}</router-link>
            <router-link to="/faqs" class="block text-sm text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Faq") }}</router-link>
            <router-link to="/premi" class="block text-sm text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("premi") }}</router-link>
            <router-link to="/documenti" class="block text-sm text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Documenti") }}</router-link>
            <router-link to="/contatti" class="block text-sm text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Contatti") }}</router-link>
            <router-link to="/login" v-if="!isAuth" class="block text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Accedi") }}</router-link>
            <router-link to="/register" v-if="!isAuth" class="block text-sm text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Registrati") }}</router-link>
            <router-link to="/dashboard" v-if="isAuth" class="block text-sm text-green-dark uppercase px-2 py-2 mr-2">{{ $t("Dashboard") }}</router-link>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mobileMenuOpen: false
        }
    },
    computed: {
        isAuth() {
            return this.$store.state.auth
        },
    },
}
</script>